import { FormFeedback } from '@backend/lib-design-system';
import type { PropsWithChildren } from 'react';

import { FilterFieldContainer, FilterLabel } from '~/components/FiltersPanel/FiltersPanel.styles';
import { useSearchFormContext } from '~/contexts/SearchFormContext/SearchFormContext';
import { useTranslation } from '~/hooks';

type FilterFieldType = 'job' | 'address' | 'type' | 'sort' | 'distance' | 'experience';

interface FilterFieldProps {
  type: FilterFieldType;
  labelData?: Record<string, any>;
}

export const FilterField = ({ type, children, labelData }: PropsWithChildren<FilterFieldProps>) => {
  const t = useTranslation();
  const { form, submitted } = useSearchFormContext();

  const error = form[type]?.error;

  return (
    <FilterFieldContainer>
      <FilterLabel>{t(`form_labels.${type}`, labelData)}</FilterLabel>
      {children}
      {submitted && error && <FormFeedback intent="danger">{t(`form_errors.${type}`)}</FormFeedback>}
    </FilterFieldContainer>
  );
};
